import { faReceipt } from '@fortawesome/pro-regular-svg-icons';
import { defineMessages } from 'react-intl';

import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import { useIntlContext } from '@sorare/core/src/contexts/intl';

type Props = {
  receiptUrl: string | null;
};

const messages = defineMessages({
  enabled: {
    id: 'RequestReceipt.enabled',
    defaultMessage: 'Request a receipt',
  },
});

export const RequestReceipt = ({ receiptUrl }: Props) => {
  const { formatMessage } = useIntlContext();

  if (!receiptUrl) return null;

  return (
    <Tooltip title={formatMessage(messages.enabled)}>
      <IconButton
        // Workaround tooltip having extra span
        aria-label={formatMessage(messages.enabled)}
        color="tertiary"
        href={receiptUrl}
        icon={faReceipt}
        {...({ target: '_blank' } as const)}
      />
    </Tooltip>
  );
};
